export default [
    {
        path: '/tendero/estadisticas',
        meta: { nombre: 'Estadisticas' },
        name: 'tendero.estadisticas',
        component: () => import(/* webpackChunkName: "promociones" */ '../../pages/estadisticas').then(m => m.default || m)
    }
]
